module.exports = __webpack_public_path__ + "static/media/icon_edit_2.e1bd2299.svg";